module.exports = __webpack_public_path__ + "static/media/thumbs_up.952ec80d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbs_up.svg
// module id = 622
// module chunks = 0